<template>
  <div class="d-flex flex-column" :class="[containerClass]">
    <label class="d-flex align-items-center fs-6 form-label mb-2">
      <span :class="required ? 'required' : ''">{{ label }}</span>
    </label>
    <div class="input-group input-group-solid mb-5">
      <input type="text" v-model="model" class="form-control form-control-lg form-control-solid" />
      <span class="input-group-text">
        <input class="border-0" style="border-color: #e4e6ef;" type="color" v-model="model"/>
      </span>
    </div>
  </div>
  <span class="text-muted">{{$t('appointment_types.color_select')}}</span>
  <div id="colors" class="colors-container mt-4">
    <div
        v-for="color in data"
        :key="color?.value"
        :style="{ backgroundColor: color?.value }"
        class="color-circle mb-2"
        @click="selectColor(color.value)"
    ></div>
  </div>
</template>

<script setup>
import { defineProps, ref } from 'vue'

const model = defineModel()

const emits = defineEmits(['getColor'])

const props = defineProps({
  label: {
    type: String,
    default: "Label"
  },
  required: Boolean,
  containerClass: String,
  iconParent: {
      type: String,
      required: false
  },
  data: {
    type: Array,
    default: []
  },
})

const isLoading = ref(false)

function selectColor(value){
  model.value = value
}

function showColorModal(){
  $('#addColorModal'+props.iconParent).modal('toggle')
}

function addColor(){
  isLoading.value = true
  props.data.push({
    id: props.data.length,
    value: selectedColor.value
  })
  emits('getColor', selectedColor.value)
  showColorModal()
  isLoading.value = false
}

</script>

<style scoped>
  .colors-container {
    display: flex;
    flex-wrap: wrap;
  }
  .color-circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 10px;
    cursor: pointer;
  }
  .color-circle.selected {
    border: 3px solid rgba(0, 114, 206, 1);
    width: 30px;
    height: 30px;
    margin-top: -3px;
  }

</style>

